import React from "react";

export const PageNotFound = () => {
  return <h1>Page not found.</h1>;
};
